import React from 'react';
import { css } from '@emotion/core';

const tptOriginalWrapper = css`
  position: absolute;
  top: 0;
  right: 0;
  padding: 2px 4px;
  background: #37a0be;
  color: #fff;
  line-height: 1.25;
  font-weight: bold;
  font-size: 12px;
  text-transform: uppercase;
`;

export default class TPTOriginal extends React.PureComponent {
  render() {
    return <div css={tptOriginalWrapper}>
      TPT Original
    </div>;
  }
}